var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeposit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.9999,
    width: 20,
    height: 14,
    rx: 1,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M6 18.5l-1.777-7.998a1 1 0 01.785-1.198L21.07 6.181a1 1 0 011.161.74L23.5 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D5AFE",
    d: "M18.998 18.524l-.652-.758-.827.71.78.763.699-.715zm9.387 1a1 1 0 100-2v2zm-7.336 2.406a1 1 0 101.399-1.43l-1.4 1.43zm1.35-5.009a1 1 0 00-1.302-1.517L22.4 16.92zm-3.401 2.603h9.387v-2h-9.387v2zm-.7-.285l2.75 2.69 1.4-1.429-2.751-2.69-1.398 1.43zm1.351.044l2.75-2.362-1.302-1.517-2.75 2.362 1.302 1.517z",
    className: "fill-primary-main"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeposit);
export default __webpack_public_path__ + "static/media/icon_deposit.a4a7adbf913f655b669c35beed30d1b0.svg";
export { ForwardRef as ReactComponent };